import './ConversationModalInformationDetails.css'
import "../ConversationDetailsModal.css"
import Field from '/src/components/UI/Field/Field';
import { formatDateWithoutSeconds } from '/src/utils/dateWithoutSeconds';
import AudioSource from '/src/components/UI/AudioSource/AudioSource';
import IconsConversation from '../../../data/types/IconsConversation';
import Icons from '/src/features/phone/data/types/Icons';
import ConversationChatbox from '../ConversationChatbox/ConversationChatbox';
import { env } from '/src/var/env';
import storage from '/src/utils/storage';
import getNumberOfInteraction from '../../../data/getNumberOfInteraction';
import getDuration from '../../../data/getDuration';
import formatPhoneNumber from '/src/utils/formatPhoneNumber';
import * as purify from "dompurify";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';

import ConversationService from '../../../services/ConversationService';
import getHangup from '../../../data/getHangup';
import HangupBadge from '../../HangupBadge/HangupBadge';

const getAudioUrl = (conversationId, objectId, download= false) => `${env.REACT_APP_API_PATH}/conversation/completed/${conversationId}/audio?object_id=${objectId}&download=${download}&token_auth=${storage('local').get('token')}`;

const ConversationModalInformationDetails = ({ data, state, onClose }) => {
    const toast = useToastDispatchContext();
    const dataCommons = [
        { name: "ID", value: <span style={{color : "var(--main)", cursor: "pointer"}} onClick={(e) => navigator.clipboard.writeText(data.instance_id).then(_ => { toast.success('Copy token to clipboard', 'You can paste this token where you need !',5000); })}>  {data.instance_id}</span> },
        { name: "Date", value: formatDateWithoutSeconds(state == 1 || state == 2 ? data.created_at : data.schedule, state == 3) },
        { name: "Bot", value: state == 1 || state == 2 ? data.name : data.bot.name },
    ]
    const dataCompleted = state == 1 || state == 2 ?
        [
            { name: "Total Duration", value: (data.duration||data.conversation_telephony_created_at) ? getDuration(data.duration, data.conversation_telephony_created_at, data.messages,data.updated_at) : '' },
            { name: "Interactions", value: getNumberOfInteraction(data.messages) },
            ...(getHangup(data) ? [{ name: "Hung up by", value: <HangupBadge conversation={data} /> }] : []),
            { name: "Caller", value: data.caller ? formatPhoneNumber(data.caller) : "Unknown" },
            { name: "Called", value: data.numbers ? formatPhoneNumber(data.numbers) : "Unknown" }
        ] : []

    const dataRow = [...dataCommons, ...dataCompleted]
    const renderChannelType = <>
        <Field label="Channel" listLabelClassName="titles-input text-bold"></Field>
        <div className="channel-icon-container">
            <img width="30px" style={{ marginLeft: "20px", marginTop: "-5px" }} srcSet={data.channel_type_id ? Icons[data.channel_type.name] : IconsConversation[data.bot_job_type.name]}></img>
        </div>
    </>
    // Fonction pour ajouter des balises HTML et des styles aux clés et aux valeurs
    const highlightJSON = (jsonString) => {
        let result = jsonString;
        result = result.replace(/"([\w\s-]+)":/g, '<span style="color: rgb(14, 122, 237);">"$1":</span>');
        result = result.replace(/: ("[^"]*")/g, ': <span style="color: green;">$1</span>');
        result = result.replace(/\\n/g, "").replace(/\\"/g, "\"").replace(/\"\"/, "\"");
        return result;
    };
    const highlightedJSON = highlightJSON(data.body ? JSON.stringify(data.body, null, 2) : "");

    return (
        <>
            {state == 1 || state == 2 ?
                <div className='block_conversation'>
                    <div className='container-conversations'>
                        <div className="grid_container_conversation_fields">
                            <div className='row-conversation'>
                                {renderChannelType}
                            </div>
                            {
                                dataRow.map((row, i) => ((i >= dataRow.length - 2 && data.channel_type_id == 3) || (i < dataRow.length - 2)) &&
                                    <div className="container_field_converation_information" >
                                        <Field label={row.name} listLabelClassName="titles-input"></Field>
                                        <Field label={row.value} listLabelClassName="titles-input conversation_detail_text_input_value conversation_detail_text_input_value_weight"></Field>
                                    </div>
                                )
                            }

                        </div>
                        <div className="conversation_follow_up_separator" style={{ marginTop: "1px" }}></div>

                        <div style={{ justifyContent: "center", display: "flex", marginTop: data.channel_type_id == 3 ? "" : "5%" }}>
                            <div className='conversation_chat_conversations'>
                                <ConversationChatbox messages={data.messages} />
                            </div>
                        </div>
                    </div>
                    {data.channel_type_id == 3 && !(data.messages.some(message => message.is_hidden == 1)) &&
                        <>
                            { /*<div className="conversation_follow_up_separator"></div> */}
                            <br></br>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <div style={{width : "75%"}}>
                                    {data.audio_object_id && data.audio_object_id.includes('.') == false ? <AudioSource className="audio_src_conversation_information_modal" picture={false} src={getAudioUrl(data.id, data.audio_object_id)} downloadUrl={getAudioUrl(data.id, data.audio_object_id,true)}/> : null}
                                </div>
                            </div>
                        </>
                    }

                </div>
                :
                <div className='conversation_modal_follow_up_block_relaunch'>
                    <div className='flex_url'>
                        <Field label="Url :" listLabelClassName="titles-input"></Field>
                        <Field label={<span> &nbsp; {data.url} </span>} listLabelClassName="titles-input conversation_detail_text_input_value_weight"></Field>
                    </div>
                    <div>
                        <Field label="Body" listLabelClassName="titles-input"></Field>
                        <pre className='conversation_modal_follow_up_body_json_detail'>
                            <code dangerouslySetInnerHTML={{ __html: purify.sanitize(highlightedJSON, { sanitize: true }) }} style={{ fontFamily: 'Nunito', fontWeight: '600px' }} />
                        </pre>
                    </div>
                </div>

            }

            {/* <div className='flex align-items-center'>
                    <Field label="Data" listLabelClassName="titles-input"></Field>
                    <Field label={props.data.audio_reference?props.data.audio_reference:"unknown"} listLabelClassName="titles-input-value"></Field>
                </div> */}
            {/* <div className='separator'></div> */}
            {
/**
     :
                <div className='block_relaunch'>
                    <div className='row_relaunch'>
                        <Field label="Channel" listLabelClassName="titles-input text-bold"></Field>
                        <Field label="ID" listLabelClassName="titles-input"></Field>
                        <Field label="Date" listLabelClassName="titles-input"></Field>
                        <Field label="Bot" listLabelClassName="titles-input"></Field>
                    </div>
                    <div className='row_relaunch' style={{ fontWeight: "400" }}>
                        <span><img width="30px" style={{ marginBottom: "-10px" }} srcSet={Icons[data.bot.channel.type_id]}></img></span>
                        <Field label={data.id} listLabelClassName="titles-input"></Field>
                        <Field label={formatDateWithoutSeconds(data.schedule)} listLabelClassName="titles-input"></Field>
                        <Field label={data.bot.name} listLabelClassName="titles-input"></Field>
                    </div>
                </div>
                */}

        </>
    );
};

export default ConversationModalInformationDetails;